<template>
  <div class="pa-3 ma-3">
    <signal-r
      :path="`${this.storage_url_base}/hub/process?jwt=${this.token}`"
      @notification-received="updateProgress"
    >
    </signal-r>
    <v-dialog
      v-model="dialogDownload"
      persistent
      max-width="50%"
    >
      <v-card>
        <v-card-title>
          Obteniendo CD DICOM
        </v-card-title>
        <v-card-text class="text-center">
          <template  v-if="downloadProgress.percentage < 100">
            <lottie :options="satelliteAnimation" :height="250" :width="250" />
          </template>

          <v-progress-linear
            :value="downloadProgress.percentage"
            color="primary"
            height="15"
          >
            <strong>{{(downloadProgress.percentage || 0).toFixed(2)}}%</strong>
          </v-progress-linear>
          {{downloadProgress.message}}
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            text
            color="green"
            @click="closeDialogDownload"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="4">
        Rango de Fechas: 
        <date-picker v-model="busquedaItem.rango" range valueType="format" format="DD-MM-YYYY"></date-picker>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_tecnico_radiologo"
          label="Técnico Radiólogo"
          :items="tecnicos_radiologos"
          item-text="nombre"
          item-value="id_usuario"
          clearable
          dense
          hide-details
          outlined
          :loading="loadingTecnicosRadiologos"
          :disabled="loadingTecnicosRadiologos"
        ></v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_radiologo"
          :items="radiologos"
          outlined
          label="Radiólogo"
          :item-text="nombreRadiologo"
          item-value="id_usuario"
          :loading="loadingRadiologos || loading"
          :disabled="loadingRadiologos || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>


      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_unidad_medica"
          :items="unidades_medicas"
          outlined
          label="Unidad Medica"
          :item-text="codigoNombre"
          item-value="id_unidad_medica"
          :loading="loadingUnidadesMedicas || loading"
          :disabled="loadingUnidadesMedicas || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_proyecto"
          :items="proyectos"
          outlined
          label="Proyecto"
          :item-text="codigoNombre"
          item-value="id_proyecto"
          :loading="loadingProyectos ||loading"
          :disabled="loadingProyectos || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.lazy="busquedaItem.folio"
          label="Folio"
          outlined
          dense
          hide-details
          :loading="loading"
          :disabled="loading"
          clearable
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          @update:page="getItems"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:[`item.paciente`]="{ item }">
            {{item.nombre}} {{item.apellido_paterno}} {{item.apellido_materno}}
          </template>
         <template v-slot:[`item.actions`]="{ item }">
            <div style="display: flex; align-items: center; gap: 8px;">
              <v-img
                src="/img/cd.png"
                width="32px"
                height="32px"
                contain
                style="cursor: pointer;"
                @click="openDialogDownload(item.id_paciente_servicio)"
              />
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import axios from 'axios'
import { mapState } from 'vuex'
import _ from 'lodash';
import Lottie from 'vue-lottie';
import SignalR from '@/components/SignalR.vue'
import satelliteAnimationData from '@/assets/satellite.json';

export default {
  components: {
    DatePicker,
    'lottie': Lottie,
    SignalR
  },
  computed: {
    ...mapState(['token', 'storage_url']),
    storage_url_base(){
      return this.storage_url.replace('/api', '');
    }
  },
  data: () => ({
    satelliteAnimation: {animationData: satelliteAnimationData, loop: true},
    loading: false,
    items: [],
    page: 1,
    itemsPerPage: 10,
    totalRecords: 0,
    headers: [
      {
          text: 'Fecha de Toma de Estudio',
          value: 'fecha_captura',
          align: 'center'
      },
      {
          text: 'Fecha de Interpretación',
          value: 'fecha_interpretacion',
          align: 'center'
      },
      {
          text: 'Folio',
          value: 'folio',
          align: 'center'
      },
      {
          text: 'Folio Servicio',
          value: 'folio_servicio',
          align: 'center'
      },
      {
          text: 'Paciente',
          value: 'paciente',
          align: 'center'
      },
      {
          text: 'Fecha de Nacimiento',
          value: 'fecha_nacimiento',
          align: 'center'
      },
      {
          text: 'Edad',
          value: 'edad',
          align: 'center'
      },
      {
          text: 'Género',
          value: 'genero',
          align: 'center'
      },
      { 
        text: "Técnico Radiólogo",
        value: "tecnico_radiologo",
        align: 'center',
        width: "11%"
      },
      {
          text: 'Radiólogo',
          value: 'radiologo',
          align: 'center'
      },
      {
          text: 'Estado',
          value: 'estado',
          align: 'center'
      },
      {
          text: 'Municipio',
          value: 'municipio',
          align: 'center'
      },
      {
          text: 'Localidad de atención',
          value: 'localidad_atencion',
          align: 'center'
      },
      {
          text: '# imágenes',
          value: 'num_imagenes',
          align: 'center'
      },
      {
          text: 'Acciones',
          value: 'actions',
          align: 'center',
      },
    ],
    busquedaItem: {
      rango: null,
      id_unidad_medica: null,
      id_proyecto: null,
      id_radiologo: null,
      id_tecnico_radiologo: null,
      folio: null,
    },
    unidades_medicas: [],
    loadingUnidadesMedicas: false,
    radiologos: [],
    loadingRadiologos: false,
    proyectos: [],
    loadingProyectos: false,
    dialogDownload: false,
    id_file_request: null,
    downloadProgress: {
      id_file_request: null,
      percentage: 0,
      message: "Iniciando Compresión"
    },
    loadingGenerateZip: false,
    loadingTecnicosRadiologos: false,
    tecnicos_radiologos: []
  }),
  mounted() {
    this.getItems();
    this.getUnidadesMedicas();
    this.getRadiologos();
    this.getProyectos();
    this.getTecnicosRadiologos();
  },
  watch: {
    'busquedaItem.rango': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_unidad_medica': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_proyecto': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_radiologo': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_tecnico_radiologo': function () {
      this.debouncedInput();
    },
    'busquedaItem.folio': function () {
      this.debouncedInput();
    }
  },
  methods: {
    codigoNombre: item => `[${item.codigo}] - ${item.nombre}`,
    nombreRadiologo: item => `${item.nombre} ${item.apellido_paterno} ${item.apellido_materno}`,
    getUnidadesMedicas(){
      this.loadingUnidadesMedicas = true;
      axios
      .get('/Catalogos/ListarUnidadesMedicas?ignore_config=true')
      .then(response => {
        this.unidades_medicas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingUnidadesMedicas = false;
      })
    },
    getRadiologos(){
      this.loadingRadiologos = true;
      axios
      .get('/ConsultasMastografias/ListarRadiologos')
      .then(response => {
        this.radiologos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingRadiologos = false;
      })
    },
    onItemsPerPageChange(value){
      this.page = 1;
      this.itemsPerPage = value;
      this.getItems();
    },
    getItems() {
      this.items = [];

      const url = new URL(`http://localhost/InterpretacionesRadiologicas/ConcentradoInterpretaciones`);
      if(this.busquedaItem.rango != null && this.busquedaItem.rango.length == 2) {
        if(this.busquedaItem.rango[0] != null) url.searchParams.append("desde", this.busquedaItem.rango[0]);
        if(this.busquedaItem.rango[1] != null) url.searchParams.append("hasta", this.busquedaItem.rango[1]);
      }
      if(this.busquedaItem.id_unidad_medica != null) url.searchParams.append("id_unidad_medica", this.busquedaItem.id_unidad_medica);
      if(this.busquedaItem.id_radiologo != null) url.searchParams.append("id_radiologo", this.busquedaItem.id_radiologo);
      if(this.busquedaItem.id_tecnico_radiologo != null) url.searchParams.append("id_tecnico_radiologo", this.busquedaItem.id_tecnico_radiologo);
      if(this.busquedaItem.id_proyecto != null) url.searchParams.append("id_proyecto", this.busquedaItem.id_proyecto);
      if(this.busquedaItem.folio != null && this.busquedaItem.folio.length > 0) url.searchParams.append("folio", this.busquedaItem.folio);
      url.searchParams.append("page", this.page);
      url.searchParams.append("size", this.itemsPerPage);
      var url_string = url.href.replace('http://localhost', '');

      this.loading = true;
      axios.get(url_string)
        .then(response => {
          this.items = response.data.results;
          this.totalRecords = response.data.total_records;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    getProyectos(){
      this.loadingProyectos = true;
      axios
      .get('/Catalogos/ListarProyectos?solo_activos=false')
      .then(response => {
        this.proyectos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingProyectos = false;
      })
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    openDialogDownload(id_paciente_servicio){
      this.dialogDownload = true;
      
      this.loadingGenerateZip = true;
      axios
      .post(`/InterpretacionesRadiologicas/GenerarISO/${id_paciente_servicio}`)
      .then(response => {
        this.id_file_request = response.data.id_file_request;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingGenerateZip = false;
      })
    },
    closeDialogDownload(){
      this.dialogDownload = false;
      this.id_file_request = null;
      this.loadingGenerateZip = false;
      this.downloadProgress.id_file_request = null;
      this.downloadProgress.percentage = 0;
      this.downloadProgress.message = "Iniciando Compresión";
    },
    updateProgress(event){
      var msg = JSON.parse(event);

      if(this.id_file_request == msg.id_file_request){
        this.downloadProgress.percentage = msg.percentage;
        this.downloadProgress.message = msg.message;

        if(msg.percentage == 100){
          var urlZip = `${this.storage_url}/Dicom/GetZipFile/${this.id_file_request}?jwt=${this.token}`; 
          this.nuevaPestana(urlZip);
        }
      }
    },
    debouncedInput: _.debounce(function() {
      this.page = 1;
      this.getItems();
    }, 1000),
    getTecnicosRadiologos(){
      this.loadingTecnicosRadiologos= true;
      axios
      .get('/ConsultasMastografias/GetTecnicosRadiologos')
      .then(response => {
        this.tecnicos_radiologos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingTecnicosRadiologos = false;
      })
    }
  }
}
</script>
